import React, { useState } from 'react'
import CreatableSelect from 'react-select/creatable';
import { useTheme } from '../../context/ThemeContext'
import { createNewTag } from '../../services/tags';

const SelectTags: React.FC<any> = ({ tags, setSelectedTags, selectedTags, transformedTags, role, isHome, boardId }) => {
    const { theme: themeDark } = useTheme()
    const [rightsMsg, setRightsMsg] = useState('')

    const colourStyles: any = {
        option: (styles: any, { isFocused, isSelected }: any) => ({
            ...styles,
            backgroundColor: isHome ? isSelected
                ? '#009ef7'
                : isFocused
                    ? themeDark === 'dark' ? '#2a2a2a' : '#f0f0f0'
                    : 'transparent' : styles.backgroundColor,
            color: isHome ? isSelected
                ? 'white'
                : themeDark === 'dark'
                    ? 'white'
                    : 'black' : styles.color,
        }),
        control: (styles: any, state: any) => ({
            ...styles,
            backgroundColor:
                isHome
                    ? (themeDark === 'dark' ? '' : '') : (themeDark === 'dark' ? '' : 'white'),
            borderColor:
                state?.isFocused ? '#d4f746' : 'hsl(0, 0%, 80%)',
            boxShadow: (state?.isFocused ? '0 0 0 1px #d4f746' : 'none'),
            '&:hover': {
                borderColor: '#d4f746',
            },
        }),

        multiValue: (styles: any) => {
            return {
                ...styles,
                backgroundColor: themeDark === 'dark' ? '#141520' : '#E6E6E6',
                color: isHome
                    ? themeDark === 'dark' ? 'white' : 'black'
                    : styles.color
            }
        },
        multiValueLabel: (styles: any, { data }: any) => ({
            ...styles,
            backgroundColor: data.isDisabled ? '#FF677E' : '',
            color: data.isDisabled ? 'white' : '',
        }),
        multiValueRemove: (styles: any, { data }: any) => ({
            ...styles,
            color: data.color,
            ':hover': {
                backgroundColor: '#FF677E',
                color: 'white',
            },
        }),
        valueContainer: (styles: any) => ({
            ...styles,
            overflow: 'auto',
            alignItems: 'flex-start',
            maxHeight: '150px',
            minHeight: '100px',
            border: isHome && 'none'
        }),
        dropdownIndicator: (styles: any) => ({
            ...styles,
            color: themeDark === 'dark' ? '#FF7C00' : 'hsl(0, 0%, 80%)',
        }),
        indicatorSeparator: (styles: any) => ({
            ...styles,
            backgroundColor:
                isHome
                    ? ''
                    : styles.backgroundColor,
        }),
        placeholder: (styles: any) => ({
            ...styles,
            color: themeDark === 'dark' ? '#98C6F0' : 'hsl(0, 0%, 80%)',
        }),
    }
    const handleCreate = async (inputValue: string) => {
        if (role !== 'Admin' && role !== 'User') {
            setRightsMsg('Do not have rights to create tags')
            setTimeout(() => {
                setRightsMsg('')
            }, 5000);
            return;
        }

        // Remove all leading "#" symbols, so tags are stored without the "#" symbol
        let tagName = inputValue.trim();
        tagName = tagName.replace(/^#+/, ''); // Remove all leading "#" symbols

        try {
            const response = await createNewTag(tagName, boardId)
            const newTag = response.data.data.tag;
            setSelectedTags((prevTags: any) => (Array.isArray(prevTags) ? [...prevTags, { label: newTag.name, value: newTag.id }] : [{ label: newTag.name, value: newTag.id }]));
            if (transformedTags) transformedTags = [...transformedTags, { label: newTag.name, value: newTag.id }];
        } catch (error) {
            // console.error('Error creating tag:', error);
        }
    };

    // Custom filter function to search tags with or without "#"
    const customFilterOption = (option: any, inputValue: string) => {
        const searchValue = inputValue.toLowerCase().trim();
        const label = option.label.toLowerCase();

        // Match if search term matches the label with or without "#"
        return label.includes(searchValue) || label.includes('#' + searchValue) || label.replace('#', '').includes(searchValue);
    };

    return (
        <>
            <CreatableSelect
                isMulti
                isClearable
                createOptionPosition="first"
                isDisabled={role === 'Guest'}
                placeholder="Add or create tags"
                options={tags}
                value={selectedTags}
                onChange={(e: any) => setSelectedTags(e)}
                onCreateOption={handleCreate}
                filterOption={customFilterOption}
                styles={colourStyles}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        neutral0: themeDark === 'dark' ? "rgb(57,73,89)" : theme.colors.neutral0,
                        neutral80: themeDark === 'dark' ? "#F4FFFD" : theme.colors.neutral80,
                        primary25: themeDark === 'dark' ? "#141520" : theme.colors.primary25
                    },
                })}
            />
            {rightsMsg.length > 0 && (<div className='text-danger'>{rightsMsg}</div>)}
        </>
    )
}

export default SelectTags
